import Bugsnag from '@bugsnag/js';

type AuthErrorReport = {
  /** Bugsnag `context`, e.g. `auth:setToken`. */
  context: string;
  /** `auth.step` metadata value, e.g. `setToken`. */
  step: string;
  /** Defaults to Bugsnag's `error`; use `warning` for non-fatal paths. */
  severity?: 'warning' | 'error';
  /** Extra non-PII fields merged into the `auth` metadata section. `step` stays authoritative. */
  metadata?: Record<string, unknown>;
};

/**
 * Report an auth-flow failure to Bugsnag from the (possibly unauthenticated) auth page.
 * Never pass PII (email, tokens) here — Bugsnag is third-party telemetry.
 */
export function reportAuthError(error: unknown, { context, step, severity, metadata }: AuthErrorReport): void {
  Bugsnag.notify(error instanceof Error ? error : new Error(String(error)), (event) => {
    if (severity) event.severity = severity;
    event.context = context;
    // Spread metadata first so a stray caller-supplied `step` can't override the authoritative one.
    event.addMetadata('auth', { ...metadata, step });
  });
}
